import {
    skinVars,
    IconEmailRegular,
    IconMobileDeviceRegular,
    BoxedRow,
    IconCommentRegular,
    EmptyState,
    Spinner,
    Text1,
} from '@telefonica/mistica';
import { t } from 'i18next';
import './index.scss';
import HeaderComponent from '../../../../../components/HeaderComponent';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getCommunications } from '../../../../../services/BillService';
import { ICommunication } from '../../../../../models/Bills.interfaces';
import { useBillsContext } from '../../../../../context/bills-context/BillsContext';
import InfiniteScroll from 'react-infinite-scroll-component';
import dayjs from 'dayjs';

const CommunicationsList = () => {
    const navigate = useNavigate();
    const [communicationList, setCommunicationList] = useState<ICommunication[]>([]);
    const [hasMore, setHasMore] = useState(true);
    const { claimId } = useBillsContext();
    const [params] = useSearchParams();
    const code = params.get('code');
    const [firstLoading, setfirstLoading] = useState(true);

    useEffect(() => {
        getCommunicationList();
    }, []);

    const getCommunicationList = async () => {
        try {
            const response = await getCommunications(claimId);
            setfirstLoading(false);
            const newItems = response.data.communications;

            setCommunicationList((prevState) => [...prevState, ...newItems]);
        } catch (error) {
            console.error(error);
            setfirstLoading(false);
            setHasMore(false);
        }
    };

    const truncateDescription = (description: string, maxLength: number): string => {
        if (!description) return '';
        if (description.length <= maxLength) return description;
        return `${description.substring(0, maxLength)} [...]`;
    };

    const getIcon = (type: string): JSX.Element => {
        switch (type) {
            case '1':
                return <IconEmailRegular size={24} color={skinVars.colors.brand} style={{ marginTop: '2px' }} />;
            case '4':
                return <IconMobileDeviceRegular size={24} color={skinVars.colors.brand} style={{ marginTop: '5px' }} />;
            default:
                return <IconEmailRegular size={24} color={skinVars.colors.brand} style={{ marginTop: '2px' }} />;
        }
    };

    const navigationBackHandler = () => navigate(`/claims/claim-detail`);

    const claimClickHandler = (communicationData: ICommunication) =>
        navigate('/claims/communications-detail', { state: { ...communicationData, code } });

    if (firstLoading) {
        return (
            <div className='c-spinner'>
                <Spinner size={24} />
                <span style={{ background: 'white' }} className='c-spinner-overlay'></span>
            </div>
        );
    }

    return (
        <div className='email-cards' id='scrollableDiv'>
            <HeaderComponent
                title={t('Communications')}
                navigationBarOnBack={navigationBackHandler}
                breadcrumbs={[
                    { title: t('invoice'), url: '/bills' },
                    { title: t('claimHistory'), url: '/claims/claim-list' },
                    { title: t('ClaimDetails'), url: '/claims/claim-detail' },
                ]}
                data={communicationList}
            />
            {communicationList.length === 0 ? (
                <div className='email-cards__emptyState'>
                    <EmptyState
                        asset={<IconCommentRegular color={skinVars.colors.brand} size={65} />}
                        title={t('noCommunications')}
                        description={t('rememberText')}
                    ></EmptyState>
                </div>
            ) : (
                <div className='email-cards__Outerdiv'>
                    <InfiniteScroll
                        dataLength={communicationList.length}
                        next={getCommunicationList}
                        hasMore={hasMore}
                        loader={<h4>{t('loading')}</h4>}
                        scrollableTarget='scrollableDiv'
                        scrollThreshold={0.9}
                    >
                        {communicationList.map((claim: ICommunication, index: number) => (
                            <div key={index} className='email-cards__Outerdiv__row'>
                                <BoxedRow
                                    asset={getIcon(claim.shippingMethod)}
                                    title={claim.title}
                                    description={`${truncateDescription(claim.message, 55)}`}
                                    extra={
                                        <div className='email-cards__Outerdiv__row-extra'>
                                            <Text1 regular>{dayjs(claim.sendDate).format('DD/MM/YYYY')}</Text1>
                                        </div>
                                    }
                                    onPress={() => claimClickHandler(claim)}
                                />
                            </div>
                        ))}
                    </InfiniteScroll>
                </div>
            )}
        </div>
    );
};

export default CommunicationsList;
